export const modalConfiguration = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered model-dialog  modal-lg'
};

export const modalConfigurationWithBackClickClose = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered model-dialog  modal-lg'
};

export const modalConfigurationWithBackClickCloseMD = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered model-dialog  modal-md'
};
export const customModalConfigurationWithBackClickClose = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
  class: ' modal-lg-c modal-dialog-centered model-dialog  modal-lg'
};
export const customModalXLConfigurationWithBackClickClose = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered model-dialog modal-xl'
};
export const customModalMXW90ConfigurationWithBackClickClose = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered model-dialog mxw-90'
};
export const modalConfigurationGrading = {
  animated: true,
  keyboard: false,
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered model-dialog  modal-lg grading_modal'
};
export const modalConfigurationGrading2 = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered model-dialog  modal-lg grading_modal2'
};

export const modalConfigurationMediumSize = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered model-dialog  modal-lg medium_size'
};
export const modalConfigurationSubjectDetails = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered model-dialog  modal-lg subject_details'
};

export const modalConfigurationSmall = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: true,
  class: 'modal-dialog-centered model-dialog  modal-sm'
};
export const deleteConfirm = {
  animated: true,
  keyboard: true,
  backdrop: true,
  ignoreBackdropClick: false,
  class: 'delete modal-lg'
};
